import { handleActions } from 'redux-actions';
import {
  REQUEST_WEB_VALUES,
  REQUEST_WEB_VALUES_SUCCESS,
  REQUEST_WEB_VALUES_FAILURE,
} from 'constants/ActionTypes';

const initialState = {
  timeStamp: null,
  loaded: false,
  isFetching: false,
  values: [],
  valuesByKey: undefined,
  links: [],
  error: null,
  hasError: false,
};

export default handleActions({
  [REQUEST_WEB_VALUES]: state => ({
    ...state,
    loaded: false,
    isFetching: true,
    hasError: false,
    timeStamp: null,
  }),
  [REQUEST_WEB_VALUES_SUCCESS]: (state, { values, valuesByKey, links }) => ({
    ...state,
    values,
    valuesByKey, // : keyBy(filter(values, x => startsWith(x.Code, 'Employee.Web')), x => replace(x.Code, 'Employee.Web.', '')),
    links,
    loaded: true,
    isFetching: false,
    timeStamp: Date.now(),
  }),
  [REQUEST_WEB_VALUES_FAILURE]: (state, { error }) => ({
    ...state,
    error,
    loaded: true,
    isFetching: false,
    hasError: true,
    timeStamp: null,
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/WebValuesReducer.js